module.exports = __webpack_public_path__ + "static/img/Store-18.c691acff.png";